export enum RequestedMedicalRecordsPerson {
  Resident = 'RESIDENT',
  FamilyPOA = 'FAMILY_POA',
  Attorney = 'ATTORNEW',
  Guardian = 'GUARDIAN',
  RegulatoryAgency = 'REGULATORY_AGENCY',
}
